import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthSsoService } from 'app/sso/auth-sso.service';
import { ssoConfig } from 'app/sso/sso.config';

// Aplicativo do usuario como o SSO devolve em /api/v1/portal/apps: a mesma lista e as mesmas URLs do menu do portal.
export interface LauncherApp {
  id: number;
  name: string;
  subtitle: string;
  uri: string;
  imageUrl: string;
  iconKey: string;
  // Fora do SSO (Documentacao, Graphboard...): abre em aba nova.
  external?: boolean;
}

// O access token vence em 15 min e o SSO nao emite refresh token para as SPAs: sem token valido para buscar de novo,
// o menu mostra a ultima lista recebida nesta aba.
const APPS_CACHE_KEY = 'pcdoc-launcher-apps';

@Component({
  selector: 'app-apps-launcher',
  templateUrl: './apps-launcher.component.html',
  styleUrls: ['./apps-launcher.component.scss'],
})
export class AppsLauncherComponent implements OnInit {
  // Chave de icone que o SSO da a este aplicativo: ele aparece na lista como o atual.
  readonly currentApp = 'record-manager';
  readonly portalUrl = ssoConfig.issuer;

  apps: LauncherApp[] = readCachedApps();
  loading = false;

  constructor(private http: HttpClient, private authSso: AuthSsoService) {}

  ngOnInit(): void {
    // Busca logo que o aplicativo abre, enquanto o token ainda vale.
    this.loadApps();
  }

  get isSsoSession(): boolean {
    return this.authSso.hasSsoSession();
  }

  loadApps(): void {
    if (this.loading || !this.authSso.isLoggedIn()) {
      return;
    }
    this.loading = true;
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + this.authSso.getAccessToken());
    this.http.get<LauncherApp[]>(ssoConfig.portalAppsUrl, { headers: headers }).subscribe(
      (apps) => {
        this.apps = apps || [];
        sessionStorage.setItem(APPS_CACHE_KEY, JSON.stringify(this.apps));
        this.loading = false;
      },
      () => {
        // Fica a lista guardada; sem nenhuma, o menu avisa e oferece o portal.
        this.loading = false;
      }
    );
  }
}

function readCachedApps(): LauncherApp[] {
  try {
    const cached = sessionStorage.getItem(APPS_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (e) {
    return null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/apps-launcher/apps-launcher.component.ts